<ng-container *transloco="let t">
  <div class="wrapper-forms">
    <form [formGroup]="form">
      <div class="single-column" style="display: block">
        <div class="right-column" style="width: 100%">
          <mat-card appearance="outlined" [formGroupName]="'referralInfo'">
            <mat-card-content>
              <div>
                <h2>
                  {{ t('Date, time of sampling, and type of fixative') }}:
                </h2>
              </div>
              <div class="row" style="align-items: center; gap: 8px">
                <div class="clumn gap-xs">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ t('Date') }}</mat-label>
                    <input appAutofocus
                      matInput
                      [matDatepicker]="picker"
                      formControlName="date"
                      [max]="today"
                    
          [min]="minDate" [max]="today"
        />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if (
                      form
                        .get(['referralInfo', 'date'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'date'])?.touched ||
                        form.get(['referralInfo', 'date'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('This field is required') }}
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ t('Time') }}</mat-label>
                    <input matInput type="time" formControlName="time" />
                    @if (
                      form
                        .get(['referralInfo', 'time'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'time'])?.touched ||
                        form.get(['referralInfo', 'time'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('This field is required') }}
                      </mat-error>
                    }
                  </mat-form-field>

                  <p>{{ t('formalin alcohol') }}</p>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ t('Other') }}</mat-label>
                    <textarea
                      matInput
                      rows="3"
                      formControlName="other"
                    ></textarea>
                    @if (
                      form
                        .get(['referralInfo', 'other'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'other'])?.touched ||
                        form.get(['referralInfo', 'other'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('This field is required') }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined" [formGroupName]="'referralInfo'">
            <mat-card-content>
              <div>
                <h2>{{ t('Information about the lesion/tumor') }}:</h2>
              </div>
              <div class="column" style="align-items: center; gap: 8px">
                <p style="margin-top: 16px">
                  {{ t('Locations on the body') }}
                </p>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-top: 8px;
                    width: 100%;
                  "
                >
                  <div
                    style="
                      display: flex;
                      gap: 12px;
                      align-items: flex-start;
                      width: 100%;
                    "
                  >
                    <mat-form-field
                      appearance="outline"
                      style="flex: 0 0 80px; width: 80px; margin-right: 8px"
                    >
                      <mat-label>{{ t('Location number 1') }}</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="distributionNumber1"
                      />
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      style="flex: 1 1 auto; width: auto; min-width: 0"
                    >
                      <mat-label>{{ t('Comment 1') }}</mat-label>
                      <textarea
                        matInput
                        rows="3"
                        formControlName="distributionComment1"
                      ></textarea>
                    </mat-form-field>
                  </div>

                  <div
                    style="
                      display: flex;
                      gap: 12px;
                      align-items: flex-start;
                      width: 100%;
                    "
                  >
                    <mat-form-field
                      appearance="outline"
                      style="flex: 0 0 80px; width: 80px; margin-right: 8px"
                    >
                      <mat-label>{{ t('Location number 2') }}</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="distributionNumber2"
                      />
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      style="flex: 1 1 auto; width: auto; min-width: 0"
                    >
                      <mat-label>{{ t('Comment 2') }}</mat-label>
                      <textarea
                        matInput
                        rows="3"
                        formControlName="distributionComment2"
                      ></textarea>
                    </mat-form-field>
                  </div>

                  <div
                    style="
                      display: flex;
                      gap: 12px;
                      align-items: flex-start;
                      width: 100%;
                    "
                  >
                    <mat-form-field
                      appearance="outline"
                      style="flex: 0 0 80px; width: 80px; margin-right: 8px"
                    >
                      <mat-label>{{ t('Location number 3') }}</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="distributionNumber3"
                      />
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      style="flex: 1 1 auto; width: auto; min-width: 0"
                    >
                      <mat-label>{{ t('Comment 3') }}</mat-label>
                      <textarea
                        matInput
                        rows="3"
                        formControlName="distributionComment3"
                      ></textarea>
                    </mat-form-field>
                  </div>
                </div>
                <!-- Schematic image -->
                <div style="margin-top: 16px; text-align: center">
                  <img
                    src="assets/image/forms/referral-for-histopathology.png"
                    alt="Histopathology schematic"
                    style="
                      max-width: 700px;
                      width: 100%;
                      height: auto;
                      display: block;
                      margin: 0 auto;
                      border: 1px solid rgba(0, 0, 0, 0.08);
                    "
                  />
                </div>
                <div class="clumn gap-xs">
                  <p>{{ t('Tissue localization (select or write)') }}:</p>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ t('Tissue location') }}</mat-label>
                    <mat-select multiple formControlName="tissueLocation">
                      <mat-option [value]="t('Skin')">{{
                        t('Skin')
                      }}</mat-option>
                      <mat-option [value]="t('Subcutaneous tissue')">{{
                        t('Subcutaneous tissue')
                      }}</mat-option>
                      <mat-option [value]="t('Muscles')">{{
                        t('Muscles')
                      }}</mat-option>
                      <mat-option [value]="t('Bones')">{{
                        t('Bones')
                      }}</mat-option>
                      <mat-option [value]="t('Mammary gland')">{{
                        t('Mammary gland')
                      }}</mat-option>
                    </mat-select>
                    @if (
                      form
                        .get(['referralInfo', 'tissueLocation'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'tissueLocation'])?.touched ||
                        form.get(['referralInfo', 'tissueLocation'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('Please select at least one option') }}
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ t('Other (specify)') }}</mat-label>
                    <textarea
                      matInput
                      rows="3"
                      formControlName="tissueOther"
                    ></textarea>
                  </mat-form-field>
                </div>

                <div class="clumn gap-xs" style="margin-top: 8px">
                  <p>{{ t('Dimensions') }}:</p>
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ t('Dimensions') }}</mat-label>
                    <input matInput formControlName="dimensions" />
                    @if (
                      form
                        .get(['referralInfo', 'dimensions'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'dimensions'])?.touched ||
                        form.get(['referralInfo', 'dimensions'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('This field is required') }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="clumn gap-xs" style="margin-top: 8px">
                  <p>{{ t('Morphology') }}:</p>
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ t('Morphology') }}</mat-label>
                    <input matInput formControlName="morphology" />
                    @if (
                      form
                        .get(['referralInfo', 'morphology'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'morphology'])?.touched ||
                        form.get(['referralInfo', 'morphology'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('This field is required') }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="clumn gap-xs">
                  <p>{{ t('Tissue consistency (circle or specify)') }}:</p>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ t('Tissue consistency') }}</mat-label>
                    <mat-select multiple formControlName="tissueConsistency">
                      <mat-option [value]="t('Firm and elastic')">{{
                        t('Firm and elastic')
                      }}</mat-option>
                      <mat-option [value]="t('Soft and elastic')">{{
                        t('Soft and elastic')
                      }}</mat-option>
                      <mat-option [value]="t('Lard-like (greasy)')">{{
                        t('Lard-like (greasy)')
                      }}</mat-option>
                    </mat-select>
                    @if (
                      form
                        .get(['referralInfo', 'tissueConsistency'])
                        ?.hasError('required') &&
                      (form.get(['referralInfo', 'tissueConsistency'])
                        ?.touched ||
                        form.get(['referralInfo', 'tissueConsistency'])?.dirty)
                    ) {
                      <mat-error>
                        {{ t('Please select at least one option') }}
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>{{ t('Other') }}</mat-label>
                    <textarea
                      matInput
                      rows="3"
                      formControlName="tissueConsistencyOther"
                    ></textarea>
                  </mat-form-field>

                  <div class="clumn gap-xs" style="margin-top: 8px">
                    <p>{{ t('Color') }}:</p>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>{{ t('Color') }}</mat-label>
                      <input matInput formControlName="color" />
                      @if (
                        form
                          .get(['referralInfo', 'color'])
                          ?.hasError('required') &&
                        (form.get(['referralInfo', 'color'])?.touched ||
                          form.get(['referralInfo', 'color'])?.dirty)
                      ) {
                        <mat-error>
                          {{ t('This field is required') }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div class="clumn gap-xs" style="margin-top: 8px">
                    <p>{{ t('Time at which the change/tumor appeared') }}:</p>
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>{{
                        t('Duration of the change/tumor')
                      }}</mat-label>
                      <input matInput formControlName="duration" />
                      @if (
                        form
                          .get(['referralInfo', 'duration'])
                          ?.hasError('required') &&
                        (form.get(['referralInfo', 'duration'])?.touched ||
                          form.get(['referralInfo', 'duration'])?.dirty)
                      ) {
                        <mat-error>
                          {{ t('This field is required') }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div
                    style="
                      margin-top: 8px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      gap: 6px;
                    "
                  >
                    <p style="margin: 0">
                      {{ t('Alterations in regional lymph nodes') }}:
                    </p>
                    <mat-radio-group
                      formControlName="regionalLymphNodes"
                      style="display: flex; flex-direction: row; gap: 12px"
                    >
                      <mat-radio-button [value]="t('Yes')">{{
                        t('Yes')
                      }}</mat-radio-button>
                      <mat-radio-button [value]="t('No')">{{
                        t('No')
                      }}</mat-radio-button>
                    </mat-radio-group>
                    @if (
                      form.get(['referralInfo', 'regionalLymphNodes'])
                        ?.invalid &&
                      (form.get(['referralInfo', 'regionalLymphNodes'])
                        ?.touched ||
                        form.get(['referralInfo', 'regionalLymphNodes'])?.dirty)
                    ) {
                      <div
                        class="error"
                        style="color: #f44336; font-size: 12px; margin-top: 4px"
                      >
                        {{ t('This field is required') }}
                      </div>
                    }
                  </div>

                  <div
                    style="
                      margin-top: 8px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      gap: 6px;
                    "
                  >
                    <p style="margin: 0">
                      {{ t('Presence of other tumors on the animal’s body') }}:
                    </p>
                    <mat-radio-group
                      formControlName="otherTumors"
                      style="display: flex; flex-direction: row; gap: 12px"
                    >
                      <mat-radio-button [value]="t('Yes')">{{
                        t('Yes')
                      }}</mat-radio-button>
                      <mat-radio-button [value]="t('No')">{{
                        t('No')
                      }}</mat-radio-button>
                    </mat-radio-group>
                    @if (
                      form.get(['referralInfo', 'otherTumors'])?.invalid &&
                      (form.get(['referralInfo', 'otherTumors'])?.touched ||
                        form.get(['referralInfo', 'otherTumors'])?.dirty)
                    ) {
                      <div
                        class="error"
                        style="color: #f44336; font-size: 12px; margin-top: 4px"
                      >
                        {{ t('This field is required') }}
                      </div>
                    }
                  </div>

                  <div
                    style="
                      margin-top: 8px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      gap: 6px;
                    "
                  >
                    <p style="margin: 0">
                      {{ t('First occurrence of the tumor') }}:
                    </p>
                    <mat-radio-group
                      formControlName="firstOccurrence"
                      style="display: flex; flex-direction: row; gap: 12px"
                    >
                      <mat-radio-button [value]="t('Yes')">{{
                        t('Yes')
                      }}</mat-radio-button>
                      <mat-radio-button [value]="t('No')">{{
                        t('No')
                      }}</mat-radio-button>
                    </mat-radio-group>

                    @if (
                      form.get(['referralInfo', 'firstOccurrence'])?.invalid &&
                      (form.get(['referralInfo', 'firstOccurrence'])?.touched ||
                        form.get(['referralInfo', 'firstOccurrence'])?.dirty)
                    ) {
                      <div
                        class="error"
                        style="color: #f44336; font-size: 12px; margin-top: 4px"
                      >
                        {{ t('This field is required') }}
                      </div>
                    }
                  </div>

                  <div
                    style="
                      margin-top: 8px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      gap: 6px;
                    "
                  >
                    <p style="margin: 0">
                      {{ t('The change has been removed in its entirety') }}:
                    </p>
                    <mat-radio-group
                      formControlName="lesionRemovedEntirely"
                      style="display: flex; flex-direction: row; gap: 12px"
                    >
                      <mat-radio-button [value]="t('Yes')">{{
                        t('Yes')
                      }}</mat-radio-button>
                      <mat-radio-button [value]="t('No')">{{
                        t('No')
                      }}</mat-radio-button>
                    </mat-radio-group>
                    @if (
                      form.get(['referralInfo', 'lesionRemovedEntirely'])
                        ?.invalid &&
                      (form.get(['referralInfo', 'lesionRemovedEntirely'])
                        ?.touched ||
                        form.get(['referralInfo', 'lesionRemovedEntirely'])
                          ?.dirty)
                    ) {
                      <div
                        class="error"
                        style="color: #f44336; font-size: 12px; margin-top: 4px"
                      >
                        {{ t('This field is required') }}
                      </div>
                    }
                  </div>
                </div>
              </div>

              <mat-form-field
                appearance="outline"
                style="width: 100%; margin-top: 16px"
              >
                <mat-label>{{ t('Veterinarian name and surname') }}</mat-label>
                <input matInput formControlName="veterinarianName" />
                <mat-error>{{ t('This field is required') }}</mat-error>
              </mat-form-field>
            </mat-card-content>
          </mat-card>
          <!-- Save is handled by the dialog Confirm button -->
        </div>
      </div>
    </form>
  </div>
</ng-container>
